import { makeStyles, createStyles } from '@material-ui/core'

export const styles = theme => createStyles({
  depotType: {
    fontSize: 18,
  },
});

export default makeStyles(styles)